<template>
  <AppLayout>
    <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 layout-spacing">
      <div class="widget widget-six">
        <div class="widget-heading">
          <div class="row">
            <div class="col-xl-12 col-md-12 col-sm-12 col-12 d-inline-flex align-items-center">
              <h4 class="me-3 my-0">Kategorie serwisowe</h4>
              <button v-if="hasPermission('canAddServiceCategory')" @click="addServiceCategory"
                      class="btn btn-primary btn-sm">
                <i class="bi bi-plus-circle me-2"></i>Dodaj kategorię
              </button>
            </div>
          </div>
        </div>
        <div class="widget-content">
          <div v-if="$page.props.errors">
            <ul style="list-style-type: none; padding: 0" v-for="error in $page.props.errors">
              <li class="alert alert-danger">{{ error }}</li>
            </ul>
          </div>

          <div class="custom-table">
            <div class="table-responsive">
              <table id="service-category-table" class="table table-hover">
                <thead>
                <tr>
                  <th>#</th>
                  <th>Nazwa kategorii</th>
                  <th>Stworzona</th>
                  <th>Zaktualizowana</th>
                  <th>Akcje</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(serviceCategory, catId) in service_categories" :key="catId">
                  <td>{{ serviceCategory.id }}</td>
                  <td>
                    <input v-if="editingId === serviceCategory.id" v-model="serviceCategory.name" class="form-control"/>
                    <span v-else>{{ serviceCategory.name }}</span>
                  </td>
                  <td>{{ formatDate(serviceCategory.created_at) }}</td>
                  <td>{{ formatDate(serviceCategory.updated_at) }}</td>
                  <td>
                    <button v-if="editingId === serviceCategory.id" @click="updateServiceCategory(serviceCategory)"
                            class="btn btn-sm btn-success me-2">
                      Zapisz
                    </button>
                    <button v-else v-if="hasPermission('canEditServiceCategory')"
                            @click="editServiceCategory(serviceCategory.id)" class="btn btn-sm btn-outline-info me-2">
                      <i class="bi bi-pencil me-2"></i>Edytuj
                    </button>
                    <button v-if="hasPermission('canDelServiceCategory')"
                            @click="deleteServiceCategory(serviceCategory.id)" class="btn btn-sm btn-danger">
                      <i class="bi bi-trash me-2"></i>Usuń
                    </button>
                  </td>
                </tr>
                <tr v-if="addingNew">
                  <td>Nowy</td>
                  <td><input v-model="newServiceCategory.name" class="form-control"/></td>
                  <td>-</td>
                  <td>-</td>
                  <td>
                    <button @click="saveNewServiceCategory" class="btn btn-sm btn-success me-1">
                      <i class="bi bi-save me-2"></i>Zapisz
                    </button>
                    <button @click="cancelNewServiceCategory" class="btn btn-sm btn-danger">
                      <i class="bi bi-x-circle me-2"></i>Anuluj
                    </button>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </AppLayout>
</template>

<script>
import AppLayout from "@/Layouts/App.vue";
import {usePermission} from "@/composables/resources/js/composables/permissions.js";

const {hasPermission} = usePermission();

export default {
  components: {AppLayout, hasPermission},
  props: {
    users: Object,
    service_categories: Array,
  },
  data() {
    return {
      hasPermission,
      editingId: null,
      addingNew: false,
      newServiceCategory: this.getEmptyForm()
    };
  },

  methods: {
    formatDate(timestamp) {
      if (!timestamp) return '';
      const date = new Date(timestamp);
      return date.toISOString().split('T')[0];
    },

    getEmptyForm() {
      return {
        id: null,
        name: ''
      };
    },

    addServiceCategory() {
      this.addingNew = true;
      this.newServiceCategory = this.getEmptyForm();
    },

    cancelNewServiceCategory() {
      this.addingNew = false;
      this.newServiceCategory = this.getEmptyForm();
    },

    editServiceCategory(id) {
      this.editingId = id;
    },

    updateServiceCategory(serviceCategory) {
      this.$inertia.put(route('service.servicecatcategory.update', serviceCategory.id), serviceCategory, {
        onSuccess: () => {
          this.editingId = null;
        }
      });
    },

    saveNewServiceCategory() {
      this.$inertia.post(route('service.servicecatcategory.store'), this.newServiceCategory, {
        onSuccess: () => {
          this.addingNew = false;
          this.newServiceCategory = this.getEmptyForm();
        }
      });
    },

    formatMoney(value) {
      return new Intl.NumberFormat('pl-PL', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }).format(value);
    },

    deleteServiceCategory(id) {
      Toast.fire({
        toast: false,
        icon: 'warning',
        title: 'Usuwanie kategorii',
        html: 'Czy na pewno chcesz usunąć wybraną kategorię?',
        showDenyButton: true,
        showClass: {popup: 'animate__animated animate__fadeInDown'},
        hideClass: {popup: 'animate__animated animate__fadeOutUp'},
        timer: false,
        position: 'center',
        showConfirmButton: true,
        confirmButtonText: 'Tak',
        denyButtonText: 'Nie',
      }).then((result) => {
        if (result.isConfirmed) {
          this.$inertia.delete(route('service.servicecatcategory.destroy', id));
        }
      })
    }
  }
}
</script>

<style>

</style>
